import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PeriodComponent } from './period/period.component';
import { AuthGuard } from '../shared/guards/auth.guard';


const routes: Routes = [
  {path: '', component: PeriodComponent,canActivate:[AuthGuard],data:{role:'Administrador'}},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PeriodsRoutingModule { }
